var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 16.0978C31.5 23.6813 26.1225 29.998 19 31.4035V21.251H22.2281H22.6577L22.7224 20.8264L23.4318 16.1731L23.5195 15.5978H22.9375H19V13.0782C19 12.5137 19.1383 12.0178 19.4376 11.6697C19.7247 11.3356 20.2233 11.0642 21.1075 11.0642H23.125H23.625V10.5642V6.60261V6.18114L23.2096 6.10982L23.125 6.60261L23.2095 6.1098L23.2094 6.10978L23.209 6.10971L23.2077 6.10948L23.2031 6.1087L23.1861 6.10586L23.1223 6.09543C23.0669 6.08653 22.9865 6.07394 22.8848 6.05887C22.6815 6.02877 22.3927 5.98874 22.0484 5.94874C21.3619 5.86899 20.4455 5.7882 19.5435 5.7882C17.6142 5.7882 15.9643 6.37837 14.7964 7.55447C13.6284 8.73069 13 10.4351 13 12.5512V15.5978H9.4375H8.9375V16.0978V20.751V21.251H9.4375H13V31.4035C5.87749 29.998 0.5 23.6811 0.5 16.0978C0.5 7.48054 7.44251 0.5 16 0.5C24.5575 0.5 31.5 7.48054 31.5 16.0978Z",
    fill: "#1877F2",
    stroke: "#5856D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.48fcaa654e559563962a128666aa1365.svg";
export { ForwardRef as ReactComponent };